function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { merge } from "lodash";
import { NoSsr } from "@material-ui/core";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/styles";
import { useConfigTheme } from "../../hooks";

const ThemeProvider = ({
  theme,
  children,
  ...restProps
}) => {
  const defaultThemeProps = useConfigTheme();
  return /*#__PURE__*/React.createElement(NoSsr, null, /*#__PURE__*/React.createElement(MuiThemeProvider, _extends({
    theme: merge({}, theme, defaultThemeProps)
  }, restProps), children));
};

ThemeProvider.propTypes = MuiThemeProvider.propTypes;
export default ThemeProvider;